import { takeLatest, all } from 'redux-saga/effects';

/* ------------- Types ------------- */

import { INIT } from '../reducers/auth';

/* ------------- Sagas ------------- */

import { init } from './auth';

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([takeLatest(INIT, init)]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js